module.exports = __webpack_public_path__ + "static/img/exercise-8.54aee14.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-8.png
// module id = 9RsK
// module chunks = 1